import {
  FETCH_CONTACTLISTS_BEGIN,
  FETCH_CONTACTLISTS_SUCCESS,
  FETCH_CONTACTDETAILS_BEGIN,
  FETCH_CONTACTDETAILS_SUCCESS,
  FETCH_CONTACTINFO_BEGIN,
  FETCH_CONTACTINFO_SUCCESS,
  FETCH_CONTACTHEADER_SUCCESS,
  FETCH_CONTACTLISTS_FAILURE,
  FETCH_STATIC_CONTACTLIST_BEGIN,
  FETCH_STATIC_CONTACTLIST_SUCCESS,
  FETCH_STATIC_CONTACTLIST_FAILURE,
  FETCH_DYNAMIC_CONTACTLIST_BEGIN,
  FETCH_DYNAMIC_CONTACTLIST_SUCCESS,
  FETCH_DYNAMIC_CONTACTLIST_FAILURE,
  FETCH_CONTACTLIST_BEGIN,
  FETCH_CONTACTLIST_SUCCESS,
  FETCH_CONTACTLIST_FAILURE,
  FETCH_WEBCATEGORIES_BEGIN,
  FETCH_WEBCATEGORIES_SUCCESS,
  FETCH_WEBCATEGORIES_FAILURE,
  FETCH_WEBSTATUS_BEGIN,
  FETCH_WEBSTATUS_SUCCESS,
  FETCH_WEBSTATUS_FAILURE,
  FETCH_PARENTCOMPANIES_BEGIN,   
  FETCH_PARENTCOMPANIES_SUCCESS,
    FETCH_PARENTCOMPANIES_FAILURE,

    FETCH_ACCOUNTS_BEGIN,
    FETCH_ACCOUNTS_SUCCESS,
    FETCH_ACCOUNTS_FAILURE,

} from "../constants/contactLists";

const initialState = {
  ContactData: [],
  ContactDetails: [],
  ContactInfo:[],
  ContactsHeader: [],
  isLoading: false,
  error: "",
  staticContactList: [],
  dynamicContactList: [],
  contactList: [],
  webCategories: [],
  webStatusTypes: [],
  parentCompanies: [],
  isStaticContactListLoading: null,
  isStaticContactListLoading: null,
  isContactListLoading: null,
  dynamicContactListError: true,
  staticContactListError: true,
    contactListError: true,
    TaxEntities:[],
};

export const getContactListsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CONTACTLISTS_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_CONTACTLISTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ContactData: payload.ContactData,
      };
    case FETCH_CONTACTDETAILS_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_CONTACTHEADER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ContactsHeader: payload.ContactsHeader,
      };
    case FETCH_CONTACTDETAILS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      ContactDetails: payload.ContactDetails,
    };
    case FETCH_CONTACTINFO_BEGIN:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_CONTACTINFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ContactInfo: payload.ContactInfo,
      };
    case FETCH_CONTACTLISTS_FAILURE:
      return {
        ...state,
        isLoading: true,
        error: payload.error,
      };
    case FETCH_STATIC_CONTACTLIST_BEGIN:
      return {
        ...state,
        isStaticContactListLoading: true,
        staticContactListError: null,
        staticContactList: []
      };
    case FETCH_STATIC_CONTACTLIST_SUCCESS:
      return {
        ...state,
        isStaticContactListLoading: false,
        staticContactListError: null,
        staticContactList: payload.ContactList
      }
    case FETCH_STATIC_CONTACTLIST_FAILURE:
      return {
        ...state,
        isStaticContactListLoading: false,
        staticContactList: [],
        staticContactListError: payload.error,
      }
    case FETCH_DYNAMIC_CONTACTLIST_BEGIN:
      return {
        ...state,
        isDynamicContactListLoading: true,
        dynamicContactListError: null,
        dynamicContactList: []
      }
    case FETCH_DYNAMIC_CONTACTLIST_SUCCESS:
      return {
        ...state,
        isDynamicContactListLoading: false,
        dynamicContactList: payload.ContactList,
        dynamicContactListError: null
      }
    case FETCH_DYNAMIC_CONTACTLIST_FAILURE:
      return {
        ...state,
        isDynamicContactListLoading: false,
        dynamicContactListError: payload.error,
        dynamicContactList: []
      }
    case FETCH_CONTACTLIST_BEGIN:
      return {
        ...state,
        isContactListLoading: true,
        contactListError: null,
        contactList: []
      }
    case FETCH_CONTACTLIST_SUCCESS:
      return {
        ...state,
        isContactListLoading: false,
        contactList: payload.ContactList,
        contactListError: null
      }
    case FETCH_CONTACTLIST_FAILURE:
      return {
        ...state,
        isContactListLoading: false,
        contactListError: payload.error,
        contactList: []
      }
      case FETCH_WEBCATEGORIES_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
      case FETCH_WEBCATEGORIES_FAILURE:
        return {
          ...state,
          isLoading: false,
          webCategories: null,
        };
      case FETCH_WEBCATEGORIES_SUCCESS:
        return {
          ...state,
          webCategories: payload.webCategories,
          isLoading: true,
        };

      case FETCH_WEBSTATUS_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
      case FETCH_WEBSTATUS_FAILURE:
        return {
          ...state,
          isLoading: false,
          webStatusTypes: null,
        };
      case FETCH_WEBSTATUS_SUCCESS:
        return {
          ...state,
          webStatusTypes: payload.webStatusTypes,
          isLoading: true,
        };
        case FETCH_PARENTCOMPANIES_BEGIN: {
          return {
            ...state,
            isLoading: true,
            error: null,
          };
        }
        case FETCH_PARENTCOMPANIES_FAILURE:
          return {
            ...state,
            isLoading: false,
            webStatusTypes: null,
          };
        case FETCH_PARENTCOMPANIES_SUCCESS:
          return {
            ...state,
            parentCompanies: payload.parentCompanies,
            isLoading: true,
          };


      case FETCH_ACCOUNTS_BEGIN: {
          return {
              ...state,
              isLoading: true,
              error: null,
          };
      }
      case FETCH_ACCOUNTS_FAILURE:
          return {
              ...state,
              isLoading: false,
              TaxEntities: null,
          };
      case FETCH_ACCOUNTS_SUCCESS:
          return {
              ...state,
              TaxEntities: payload.TaxEntities,
              isLoading: true,
          };


    default:
      return state;
  }
};

export default getContactListsReducer;
